module.exports = __webpack_public_path__ + "static/media/parts_14.7b1316f7.svg";